/* eslint-disable sort-keys */
import React, { useRef } from 'react';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import classNames from 'classnames';

import Reward from './Reward';

import './RewardsSummary.scss';
import IDashboardData from 'pages/Dashboard/IDashboardData';
import Loading from 'components/Loading';

type IRewardSummary = {
  boxed?: boolean
  data: IDashboardData
  isLoading: boolean
  withTitle?: boolean
}

const Rewards = ({ data, isLoading, boxed = false, withTitle = false }: IRewardSummary) => {
  const ref = useRef(null);

  // *_usd come back null when the BTC price feed is unavailable (vs a real 0
  // when the amount is genuinely zero). Keep null so the USD line is hidden
  // rather than showing a misleading "≈ 0 USD".
  const toUsd = (raw?: string | null) =>
    (raw === null || raw === undefined ? null : parseFloat(raw));

  const rewards = {
    ['Unconfirmed Rewards']: {
      amount: parseFloat(data?.rewards_unconfirmed ?? '0'),
      inDollars: toUsd(data?.rewards_unconfirmed_usd),
    },
    ['Total Rewards']: {
      amount: parseFloat(data?.rewards_total ?? '0'),
      inDollars: toUsd(data?.rewards_total_usd),
    },
    ['Available Balance']: {
      amount: parseFloat(data?.balance_available ?? '0'),
      inDollars: toUsd(data?.balance_available_usd),
    },
  };

  return (
    <SwitchTransition>
      <CSSTransition
        nodeRef={ref}
        classNames='fade'
        timeout={300}
        mountOnEnter={true}
        unmountOnExit={true}
        key={isLoading ? 1 : 0}
      >

        <div ref={ref} className='rewards-summary'>
          { withTitle && (<h3>Rewards</h3>)}
          <div className={classNames({
            boxed,
            isLoading,
            'neu-row': true,
          })}>
            {isLoading && <Loading />}
            {
              Object.entries(rewards).map(([key, value]) => (
                <Reward
                  key={key}
                  name={key}
                  {...value}
                />
              ))
            }
          </div>
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
};

export default Rewards;
